import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ESIMOrdersLoading = () => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={3}>
      <CircularProgress size={40} />
      <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
        {t("esim.orders.loading")}
      </Typography>
    </Box>
  );
};

export default ESIMOrdersLoading;
